import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER } from '@/styles/common.styled';

export const ComponentWrapper = styled('div', {
    isDisabled: Boolean,
    customStyle: Array,
})`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 11px 16px;
    margin-top: -16px; /* Overlap with Period section border */
    border: 1px solid ${GRAY(20)};
    border-top: none; /* Remove top border to connect with Period */
    border-radius: 0 0 2px 2px; /* Only bottom border radius */
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg.ga4utm-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }

            h1 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 6px;
            }
        }

        .dropdown-wrapper {
            position: relative;
            min-width: 300px;
        }
    }

    ${({ customStyle }) => customStyle}
`;
